import "./contact.scss";
import ContactUs from "../../components/contact-us";

const Contact = () => {
  return (
    <>
    <ContactUs/>
  
    </>
  );
};

export default Contact;